var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "#EE3E2C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2042 7.33638C17.9471 6.40372 17.3174 5.93514 16.803 6.00723C16.474 6.04052 16.1581 6.15528 15.8829 6.34144C15.6077 6.5276 15.3816 6.7795 15.2244 7.07505C14.4662 8.80069 16.0448 13.883 16.2887 14.7345C14.7367 19.4474 9.47765 28.7649 6.90136 29.3957C6.84815 28.7784 7.17185 26.9987 10.5729 24.7775C10.7433 24.5972 10.9004 24.4045 11.0429 24.2007C8.16955 25.629 4.45809 27.9133 6.67521 29.63C6.83728 29.7394 7.01332 29.8258 7.19845 29.8868C8.9145 30.5311 11.3134 28.4225 13.7257 23.6421C16.2699 22.7208 18.893 22.042 21.561 21.6145C24.8778 23.8989 27.1038 24.3674 28.6159 23.7772C28.9115 23.6473 29.1772 23.4559 29.3956 23.2154C29.614 22.9748 29.7804 22.6904 29.8841 22.3805C28.6558 23.9124 25.7824 22.831 23.4899 21.3802C25.605 21.146 27.7911 21.0108 28.7356 21.3127C29.9373 21.6956 29.8974 22.2994 29.8841 22.3805C29.9656 22.1749 30.0049 21.9545 29.9995 21.7329C29.9942 21.5113 29.9443 21.2932 29.853 21.0919C28.8464 19.4203 24.2171 20.3935 22.5321 20.5692C19.876 18.9382 18.0402 16.0366 17.3174 13.937C18.0047 11.2337 18.7452 9.27828 18.2042 7.33638ZM17.0425 12.9954C16.5991 11.3914 15.9783 7.82748 16.976 6.68757C18.9315 7.82298 17.7165 10.5218 17.0425 12.9954ZM20.6963 20.9387C18.3629 21.4088 16.0855 22.1308 13.903 23.0924C15.0313 20.6154 15.9726 18.0549 16.7188 15.4329C17.6839 17.5184 19.0394 19.393 20.7096 20.9522",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.cb172ee22ccf64d84f114e79b3b2cfd6.svg";
export { ForwardRef as ReactComponent };